export const smsNumber = state => state.smsNumber;
